import { render, staticRenderFns } from "./betalingen.html?vue&type=template&id=018bd242&"
import script from "./betalingen.js?vue&type=script&lang=js&"
export * from "./betalingen.js?vue&type=script&lang=js&"
import style0 from "./betalingen.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports